export const locale = {
    lang: 'pl',
    data: {
        "Title": "Tytuł",
        "Title is required!": "Tytuł jest wymagany!",
        "Description": "Treść",
        "Description is required!": "Treść jest wymagana!",
        "New note": "Nowa notatka",
        "Cancel": "Anuluj",
        "Create": "Zapisz",
        "Do you really want to delete selected note?": "Czy chcesz usunąć wybraną notatkę?",
        "Response": "Odpowiedź",
        "Send": "Wyślij",
        "Delete note": "Usuń notatkę",
        "Delete": "Usuń",
        "Do you want to confirm selected note?": "Czy chcesz potwierdzić notatkę?",
        "Confirm": "Potwierdź",
        "Confirm note": "Potwierdź notatkę",
    }
};
